module.exports = __webpack_public_path__ + "assets/img/thumb_ch1_news-item-2.0d1f4a41.jpg";